import { module } from "angular";
import { LoginService } from "./LoginService";

module("mmAuth").service("mmLoginService", LoginService);
